<template>
    <EditeFicheInventaire/>
</template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
    import EditeFicheInventaire from "@/components/GesCom/Inventaire/EditeFicheInventaire.vue";

    export default defineComponent({
      name: "EdietFicheInventairePage",
      components: {
        EditeFicheInventaire,
      },
    });
  </script>